import { Bootstrap5Pagination } from 'laravel-vue-pagination';

export default {
    install(app) {
        app.use(Bootstrap5Pagination);
    }
};